import { useEffect } from 'react';
import { Mode, webOsMode } from '../../../common/types';
import { useAnalytics } from '../../contexts/AnalyticsContext/useAnalytics';

/**
 * Only exported for tests
 */
export const webosRedirect = (
  _params: any,
  setUtmParameters: (id: string) => void
): string | undefined => {
  if (window.webOS && window.webOS.platform.tv === true) {
    try {
      const launchParams = window.webOSDev.launchParams();
      if (launchParams.deeplink) {
        const uriParams = /yleareena:\/\/(items|packages)\/([\w-]+)/.exec(
          launchParams.deeplink
        );
        const id = uriParams?.[2];

        if (id?.length) {
          setUtmParameters(id);

          return launchParams.deeplink as string;
        }
      }
    } catch (e) {
      const message = e instanceof Error ? e.message : e;
      window.elasticApm.captureError(new Error('TizenPreview: ' + message));
    }
  }
};

export const useWebosPreview = (
  mode: Mode,
  setWebosPreview: (deeplink: string) => void
) => {
  const { setUtmParameters } = useAnalytics();

  const setUtmParametersById = (id: string) =>
    setUtmParameters(mode, false, id);

  const webosRedirectCallback = (params: any) => {
    const redirect = webosRedirect(params, setUtmParametersById);

    if (!redirect) {
      return;
    }

    setWebosPreview(redirect);
  };

  useEffect(() => {
    if (mode === webOsMode) {
      document.addEventListener('webOSLaunch', webosRedirectCallback, true);
      document.addEventListener('webOSRelaunch', webosRedirectCallback, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);
};
